<div class="flex flex-justify-between-s flex-justify-between-m">
    <p class="s2 col-2">{{'Available to purchase in'|translate}} {{store?.data?.store_name}} {{'store'|translate}}</p>

    <button type="button"
            [iCmsModalOpen]="'seeInStoreModalStoreDetails'"
            [iCmsModalOpenData]="store">
        <i class="icon-info-2 m-l-3 col-4"
           aria-hidden="true"
           [style.font-size.rem]="1"></i>
    </button>
</div>
@if (store?.directions) {
<a [attr.href]="store.directions"
   target="_blank"
   class="col-11 c1 underline block">{{'Get Directions'|translate}}</a>
}
